<template>
  <Head title="Booking Request Sent" />

  <div class="min-h-screen bg-gradient-to-br from-black via-purple-950 to-black text-white flex items-center justify-center px-4">
    <div class="max-w-lg w-full text-center">

      <!-- Success Icon -->
      <div class="mb-8">
        <div class="w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-fuchsia-600/30 to-cyan-600/30 border border-white/20 flex items-center justify-center">
          <svg class="w-12 h-12 text-fuchsia-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      <h1 class="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-fuchsia-400 to-cyan-400 bg-clip-text text-transparent">
        Request Received!
      </h1>

      <p class="text-white/60 mb-2">
        Hi <span class="text-white font-medium">{{ booking.name }}</span>! Your booking request for
      </p>
      <p class="text-fuchsia-400 font-semibold mb-2">{{ booking.event_date }}</p>
      <p class="text-white/60 mb-10">at <span class="text-white">{{ booking.event_location }}</span> has been received.</p>

      <!-- WhatsApp CTA -->
      <div class="bg-white/5 border border-white/10 rounded-2xl p-6 mb-6">
        <p class="text-white/70 text-sm mb-4">
          Send your booking details directly to CLAUH.DJ on WhatsApp to speed things up:
        </p>
        <a :href="whatsapp_url" target="_blank"
           class="flex items-center justify-center gap-3 w-full py-4 bg-[#25D366] hover:bg-[#20b858] rounded-xl font-bold text-lg transition-all hover:scale-105 hover:shadow-lg hover:shadow-green-500/25">
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Send via WhatsApp
        </a>
      </div>

      <a href="/" class="text-white/40 hover:text-white/70 text-sm transition-colors">
        ← Back to site
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Head } from '@inertiajs/vue3'

defineProps<{
  booking: {
    name: string
    event_date: string
    event_location: string
  }
  whatsapp_url: string
}>()
</script>
